<template>
    <div class="order">
        <span>{{order}}</span><span v-show="!(total==0)">/{{total}}</span>
    </div>
</template>
<script>
export default {
    name:'ordervue',
    props:['order','total'],
}
</script>
<style lang="css" scoped>
    .order{
        font-size:0.14rem;
        display: inline;
        font-style: italic;
        margin:0 0.05rem;
        font-weight: bold;
        /* width: 0.5rem; */
        margin-top: 2px;
    }
    .order span:first-child{
        color: #ff064e;
    }
    .order span:last-child{
        color: #b8b8b8;
        font-size:0.12rem;
    }
</style>


// WEBPACK FOOTER //
// src/components/issue/order.vue